import furnitureController from "../../Api/furnitureController";
import { useParams } from "react-router-dom";
import { FC, useCallback, useState } from "react";
import { useEffect } from "react";
import { IFurniture, IModule } from "../../interfaces/IFurniture";
import Layout from "../../components/layout/Layout";
import "yet-another-react-lightbox/styles.css";
import LoadingAnimation from "../../components/_common/Loading";
import FurnitureItem from "./FurnitureItem/FurnitureItem";

interface IParams {
  furnitureId?: string;
}

interface PieceOfFurnitureProps {
  children?: React.ReactNode;
}

const PieceOfFurniture: FC<PieceOfFurnitureProps> = ({
  children
}) => {
  const [pieceOfFurnitureData, setPieceOfFurnitureData] = useState<IFurniture | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [showEditTools, setShowEditTools] = useState(false);
  const [index, setIndex] = useState(0);
  const [showImageView, setShowImageView] = useState(false);

  const params: IParams = useParams();


  const getPieceOfFurniture = useCallback(async () => {
    setLoading(true);
    if (!params.furnitureId) return;
    const res = await furnitureController.getPieceOfFurniture(
      params.furnitureId
    );
    if (res.ok) {
      setPieceOfFurnitureData(res.furniture);
    }
    setLoading(false);
  }, [params.furnitureId])


  const handleSetModules = useCallback((modules: IModule[]) => {
    setPieceOfFurnitureData((prev) => {
      if (!prev) return null;
      return {
        ...prev,
        modules: modules,
      };
    });
  }, [])


  useEffect(() => {
    getPieceOfFurniture();
  }, [
    getPieceOfFurniture,
  ]);


  const renderPieceOfFurniture = () => {
    if (loading) return <LoadingAnimation />

    if (!pieceOfFurnitureData) return <div>Dany mebel nie znajduje się w bazie</div>

    return (
      <FurnitureItem
        index={index}
        onSetIndex={setIndex}
        id={pieceOfFurnitureData._id}
        showEditTools={showEditTools}
        showImageView={showImageView}
        onSetModules={handleSetModules}
        name={pieceOfFurnitureData.name}
        width={pieceOfFurnitureData.width}
        depth={pieceOfFurnitureData.depth}
        price={pieceOfFurnitureData.price}
        images={pieceOfFurnitureData.images}
        height={pieceOfFurnitureData.height}
        onSetShowEditTools={setShowEditTools}
        onSetShowImageView={setShowImageView}
        modules={pieceOfFurnitureData.modules}
        onRefreshFurniture={getPieceOfFurniture}
        producerId={pieceOfFurnitureData.producer}
        crossedPrice={pieceOfFurnitureData.crossed}
        viewsCounts={pieceOfFurnitureData.viewCount}
        description={pieceOfFurnitureData.description}
        showPrice={pieceOfFurnitureData.isPriceVissible}
        lastViewedAt={pieceOfFurnitureData.lastViewedAt}
        furniturePremises={pieceOfFurnitureData.premises}
        partCollection={pieceOfFurnitureData.partCollection}
        onSetLoading={(loading: boolean) => setLoading(loading)}
        thumbnailImages={pieceOfFurnitureData.thumbnailImagesPaths}
        furnitureCategories={pieceOfFurnitureData.furnitureCategories}
        isModule={Array.isArray(pieceOfFurnitureData.modules) && pieceOfFurnitureData.modules.length > 0}
      />
    )
  }

  return (
    <Layout title={pieceOfFurnitureData?.name || "Mebel"}>
      {children} {/* Konieczne do działania valuationPage */}
      {renderPieceOfFurniture()}
    </Layout>
  );
}

export default PieceOfFurniture;